import { useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { useOrbVoice } from "@/lib/orbVoice";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Footprints, Loader2 } from "lucide-react";

// The Coach asks how yesterday's Mission went — tried it, or carry it into today.
export default function MissionCheckIn({ checkin, onDone }) {
  const { user } = useAuth();
  const { speak } = useOrbVoice(user?.voice || "sage", "routine");
  const [mode, setMode] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [reply, setReply] = useState(null);
  if (!checkin) return null;

  const send = async (did) => {
    setBusy(true);
    try {
      const { data } = await api.post("/missions/checkin", { did, text });
      setReply(data.reply); speak(data.reply); onDone?.();
    } catch { setReply("I couldn't save that just now — try again in a moment."); }
    finally { setBusy(false); }
  };

  return (
    <motion.section initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
      className="mb-10 rounded-3xl border border-primary/25 bg-primary/[0.05] p-5 sm:p-6" data-testid="mission-checkin">
      <p className="text-[10px] uppercase tracking-[0.22em] text-primary flex items-center gap-1.5"><Footprints className="w-3 h-3" /> Yesterday's Mission</p>
      <p className="font-serif text-lg sm:text-xl leading-snug mt-2" data-testid="mission-checkin-question">{reply || checkin.question}</p>
      {!reply && !mode && (
        <div className="flex flex-wrap gap-2 mt-4">
          <Button size="sm" className="rounded-full" onClick={() => setMode("did")} data-testid="mission-checkin-yes">Yes, I tried it</Button>
          <Button size="sm" variant="outline" className="rounded-full" disabled={busy} onClick={() => send(false)} data-testid="mission-checkin-not-yet">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Not yet"}
          </Button>
        </div>
      )}
      {!reply && mode === "did" && (
        <div className="mt-4 space-y-3">
          <Textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder="How did it go? Even the awkward bits." data-testid="mission-checkin-text" />
          <Button size="sm" className="rounded-full" disabled={busy} onClick={() => send(true)} data-testid="mission-checkin-send">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Tell my Coach"}
          </Button>
        </div>
      )}
    </motion.section>
  );
}
